const DEV_USER_ID_STORAGE_KEY = 'qc_dev_provider_user_id';

export function isDevAuthEnabled() {
  return process.env.NODE_ENV === 'development';
}

/**
 * Telegram / MAX provider_user_id for debug login (POST /api/v1/auth/login).
 * Priority: URL ?telegram_id= / ?provider_user_id= → localStorage → REACT_APP_DEV_TELEGRAM_ID.
 */
export function getDevProviderUserId() {
  if (!isDevAuthEnabled() || typeof window === 'undefined') {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get('telegram_id') || params.get('provider_user_id');
  if (fromUrl) {
    localStorage.setItem(DEV_USER_ID_STORAGE_KEY, fromUrl);
    return fromUrl;
  }

  const fromStorage = localStorage.getItem(DEV_USER_ID_STORAGE_KEY);
  if (fromStorage) {
    return fromStorage;
  }

  return process.env.REACT_APP_DEV_TELEGRAM_ID || null;
}
